module.exports = __webpack_public_path__ + "media/icons/pochodzenie-polska-white-cab30beb.png";